import React from "react";
import { recursiveMap } from "web/react/components/feeds-filters/feed-filter-categories/feed-filter-categories";
import { CategoryFilterOption, UniversalFilterSection } from "web/types/universal-filters";

export type FilterSection = (typeof FILTER_SECTION)[keyof typeof FILTER_SECTION];

export const FILTER_SECTION = {
    genderFilter: "section-gender",
    saleFilter: "section-discount-from",
    brandFilter: "section-designer-slug",
    categoryFilter: "section-category",
    sizeFilter: "section-sizes",
    priceFilter: "section-final-price",
    colorFilter: "section-color",
    moreFilter: "section-more-filters",
    shippingFilter: "section-shipping",
    materialFilter: "section-material",
    retailerFilter: "section-retailer-slug",
    extraAttributeFilter: "section-attribute",
    // CW-1978 - Experiment filters
    taxonomyDressStyleFilter: "section-style",
    taxonomyDressLengthFilter: "section-dress-length",
    taxonomyDressNecklineFilter: "section-neckline",
    taxonomyDressOccasionFilter: "section-occasion",
    taxonomyDressSleeveFilter: "section-sleeve",
} as const;

export function getServerSideFilterLinks(filterSectionList: UniversalFilterSection[]): any {
    const categoryFilterSectionList = filterSectionList.find(
        (filter) => filter.id === FILTER_SECTION.categoryFilter
    );
    const colorFilterSectionList = filterSectionList.find(
        (filter) => filter.id === FILTER_SECTION.colorFilter
    );

    const categoryFilterOptions = categoryFilterSectionList?.option_groups[0].options as
        | CategoryFilterOption[]
        | undefined;
    const allFlatCategories = recursiveMap(categoryFilterOptions);
    // Fetching server-side rendered links for initial page load
    const seoCategoryLinks = allFlatCategories?.map((categoryListOptions) =>
        // Render all categories within the same subcategory else only render checked child categories
        categoryListOptions.options.map((option) => {
            if (
                option.checked ||
                categoryListOptions.viewAllChecked ||
                option.children.length < 1
            ) {
                return (
                    <a
                        style={{ display: "none" }}
                        key={`filter-pill-${option.id}`}
                        href={option.url}
                        onClick={(e) => e.preventDefault()}
                        id={option.id}
                    >
                        {option.label}
                    </a>
                );
            }
        })
    );
    const seoColorLinks =
        colorFilterSectionList && colorFilterSectionList?.option_groups
            ? colorFilterSectionList?.option_groups[0].options.map((color) => {
                  return (
                      <a
                          style={{ display: "none" }}
                          key={`filter-pill-${color.id}`}
                          href={color.url}
                          onClick={(e) => e.preventDefault()}
                          id={color.id}
                      >
                          {color.label}
                      </a>
                  );
              })
            : [];

    return { seoCategoryLinks, seoColorLinks };
}
